<template>
  <div class="rule" :class="[cssType, { 'has-design-title': designTitle }]">
    <div class="section-head artwork-head">
      <img v-if="designTitle" class="design-title" :src="designTitle" :alt="$t('novShopping.rule.title')" />
      <template v-else>
        <img class="part-watermark" :src="partWatermark" alt="" />
        <div class="title-row">
          <img class="gift" :src="giftImg" alt="" />
          <img v-if="titleImg" class="main-title" :src="titleImg" :alt="$t('novShopping.rule.title')" />
        </div>
      </template>
    </div>
    <div class="rule-content">{{ $t('novShopping.rule.content') }}</div>
  </div>
</template>

<script setup>
import { isMobile } from '@/utils'
import titleImg from '../../assets/imgs/rule/mainTitle/index.js'
import partWatermark from '../../assets/imgs/rule/part4-watermark.png'
import giftImg from '../../assets/imgs/goods/gift.png'
import { ruleTitle as designTitle } from '../../assets/imgs/sectionTitles'

const cssType = isMobile ? 'mobile' : 'pc'
</script>

<style lang="less" scoped src="./pc_style.less"></style>
<style lang="less" scoped src="./mobile_style.less"></style>
